import React, { useContext } from "react";
// import Product from "./Product";
import { ProductContext } from "../components/context/Context";
import Shop from "./Shop";

const ProductList = () => {
  const {
    state: { products },
  } = useContext(ProductContext);

  return (
    <>
      {/* <div className="maincontent-area">
        <div className="zigzag-bottom"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="latest-product">
                <h2 className="section-title">Latest Products</h2>
                <div className="product-carousel">
                  {products.length > 0
                    ? products.map((product) => (
                        <Product key={product.id} product={product} />
                      ))
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="product-big-title-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="product-bit-title text-center">
                <h2>Shop</h2>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="single-product-area">
        <div className="zigzag-bottom"></div>
        <div className="container">
          <div className="row">
            {products.length > 0
              ? products.map((product) => (
                  <Shop key={product.id} product={product} />
                ))
              : null}
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;
